import { Alert, Button } from "@theorgchartdev/storybook";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import cx from "classnames";
import { GetWSMgr } from "@/Utils/StateLib";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import { appstr } from "@coreapp/utils/appstr";

export const getPlanConflictCount = () => {
  const wsMgr = GetWSMgr();
  const planMgr = wsMgr?.GetPlanMgr();
  if (!planMgr) {
    return null;
  }
  return planMgr.fTrackList.GetFilteredObjectCount();
};

export const ConflictDetectionAlert = props => {
  const { conflictContextValue } = usePlanManagerContext();
  const { setShowConflictModal, setConflictOverride } = conflictContextValue;
  const ctx = useWSMgrContext();
  const wsMgr = ctx.wsMgr?.state;
  if (!wsMgr) {
    return null;
  }

  const planMgr = wsMgr.GetPlanMgr();
  if (!planMgr) {
    return null;
  }
  const conflictCount = planMgr.fTrackList.GetFilteredObjectCount();
  if (conflictCount === 0) {
    return null;
  }

  let label = appstr("Conflicts detected").toLowerCase();
  if (conflictCount === 1) {
    label = appstr("Conflict detected").toLowerCase();
  }

  const handleResolveClick = () => {
    setConflictOverride(null);
    setShowConflictModal(true);
  };

  const canUpdatePlan = planMgr.CanUpdatePlan();
  const showResolveButton = props?.showButton && canUpdatePlan;

  return (
    <Alert
      alertActions={{
        customAction: showResolveButton ? (
          <Button
            dataTestId={"plan-conflicts-shortcut"}
            size={"small"}
            modifier={"primary"}
            color="error"
            onClick={handleResolveClick}
          >
            {appstr("Resolve")}
          </Button>
        ) : undefined
      }}
      severity="error"
      showIcon
      className="oc-data-source-details"
    >
      {`${conflictCount} ${label}`}
    </Alert>
  );
};
